export default $(()=>{

  // var $sidebar = $('aside.primary');
    // $('.toggle-filter').click(function(e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     $sidebar.toggleClass('-slideout');
    // });

    // $('html').click(function() {
    //     if ($sidebar.hasClass('-slideout') ) {
    //         $sidebar.removeClass('-slideout');
    //     }
    // });

    var $sidebar = $('aside.primary');
    var $filterWrapper = $('.filter-wrapper');
    var $filterSidebar = $('.filter-sidebar');

    $('.toggle-filter').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $sidebar.toggleClass('-slideout');
        $(this).toggleClass('filter-opened filter-closed');
    });

    $(document).on('click', function(e) {
        if ($sidebar.is('.-slideout')) {
            if ($.contains($sidebar[0], e.target)) {
                return null;
            } else if (!($sidebar.is(e.target))) {
                $sidebar.removeClass('-slideout');
            }
        }
    })

    // $(document).on('click', function(e) {
    //     if ($sidebar.is('.-slideout') && !($sidebar.is(e.target) || $.contains($sidebar, e.target))) {
    //         $sidebar.removeClass('-slideout');
    //     }
    // })

    if( $filterSidebar.length ) {
        $filterWrapper.addClass('-active');
    }

});